import {Component, EventEmitter, OnInit, Output, Input} from '@angular/core';
import QuillBetterTable from 'quill-better-table';
import * as Quill from 'quill';
import {ToastMessagesService} from '../../../services/toast-messages.service';

const tableImage = `<svg
    xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
    xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
    xmlns:cc="http://web.resource.org/cc/"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    xmlns:dc="http://purl.org/dc/elements/1.1/"
    xmlns:svg="http://www.w3.org/2000/svg"
    xmlns:ns1="http://sozi.baierouge.fr"
    id="svg1"
    sodipodi:docname="inserttable.svg"
    viewBox="0 0 60 60"
    sodipodi:version="0.32"
    version="1.0"
    y="0"
    x="0"
    inkscape:version="0.38.1"
    sodipodi:docbase="/home/danny/flat/scalable/actions"
  >
  <sodipodi:namedview
      id="base"
      bordercolor="#666666"
      inkscape:pageshadow="2"
      inkscape:window-width="1016"
      pagecolor="#ffffff"
      inkscape:zoom="6.9465337"
      inkscape:window-x="0"
      borderopacity="1.0"
      inkscape:cx="32.470847"
      inkscape:cy="17.130398"
      inkscape:window-y="0"
      inkscape:window-height="685"
      inkscape:pageopacity="0.0"
  />
  <rect
      id="rect863"
      style="stroke-linejoin:round;fill-rule:evenodd;stroke:#333333;stroke-width:2.3027;fill:#cccccc"
      rx="1.4752"
      transform="matrix(1.3571 0 0 1.3571 -10.732 -10.566)"
      height="27.712"
      width="37.429"
      sodipodi:stroke-cmyk="(0.0000000 0.0000000 0.0000000 0.80000001)"
      y="15.913"
      x="11.337"
  />
  <path
      id="path865"
      style="stroke:#333333;stroke-width:2.5;fill:none"
      d="m5.1419 36.127h50.306"
      sodipodi:stroke-cmyk="(0.0000000 0.0000000 0.0000000 0.80000001)"
  />
  <path
      id="path867"
      style="stroke:#333333;stroke-width:2.5;fill:none"
      d="m5.1419 23.771h50.306"
      sodipodi:stroke-cmyk="(0.0000000 0.0000000 0.0000000 0.80000001)"
  />
  <path
      id="path869"
      style="stroke:#333333;stroke-width:2.5;fill:none"
      d="m30.051 11.518v36.387"
      sodipodi:stroke-cmyk="(0.0000000 0.0000000 0.0000000 0.80000001)"
  />
  <metadata
    >
    <rdf:RDF
      >
      <cc:Work
        >
        <dc:format
          >image/svg+xml</dc:format
        >
        <dc:type
            rdf:resource="http://purl.org/dc/dcmitype/StillImage"
        />
        <cc:license
            rdf:resource="http://creativecommons.org/licenses/publicdomain/"
        />
        <dc:publisher
          >
          <cc:Agent
              rdf:about="http://openclipart.org/"
            >
            <dc:title
              >Openclipart</dc:title
            >
          </cc:Agent
          >
        </dc:publisher
        >
        <dc:title
          >ftinserttable</dc:title
        >
        <dc:date
          >2011-01-31T02:01:36</dc:date
        >
        <dc:description
          >Originally uploaded by Danny Allen for OCAL 0.18 this icon is part of the flat theme</dc:description
        >
        <dc:source
          >https://openclipart.org/detail/112873/ftinserttable-by-anonymous</dc:source
        >
        <dc:creator
          >
          <cc:Agent
            >
            <dc:title
              >Anonymous</dc:title
            >
          </cc:Agent
          >
        </dc:creator
        >
        <dc:subject
          >
          <rdf:Bag
            >
            <rdf:li
              >flat</rdf:li
            >
            <rdf:li
              >icon</rdf:li
            >
            <rdf:li
              >theme</rdf:li
            >
          </rdf:Bag
          >
        </dc:subject
        >
      </cc:Work
      >
      <cc:License
          rdf:about="http://creativecommons.org/licenses/publicdomain/"
        >
        <cc:permits
            rdf:resource="http://creativecommons.org/ns#Reproduction"
        />
        <cc:permits
            rdf:resource="http://creativecommons.org/ns#Distribution"
        />
        <cc:permits
            rdf:resource="http://creativecommons.org/ns#DerivativeWorks"
        />
      </cc:License
      >
    </rdf:RDF
    >
  </metadata
  >
</svg
>`;
declare let QuillToolbarButton: any;
const toolbar = [
    ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
    ['blockquote', 'code-block'],

    [{header: 1}, {header: 2}],               // custom button values
    [{list: 'ordered'}, {list: 'bullet'}],
    [{script: 'sub'}, {script: 'super'}],      // superscript/subscript
    [{indent: '-1'}, {indent: '+1'}],          // outdent/indent
    [{direction: 'rtl'}],                         // text direction

    [{size: ['small', false, 'large', 'huge']}],  // custom dropdown
    [{header: [1, 2, 3, 4, 5, 6, false]}],

    [{color: []}, {background: []}],          // dropdown with defaults from theme
    [{font: []}],
    [{align: []}],

    ['clean'],                                         // remove formatting button
    ['link', 'image'],
];
const betterTable = {
    operationMenu: {
        items: {
            insertColumnRight: {
                text: 'Προσθήκη στήλης από δεξιά'
            },
            insertColumnLeft: {
                text: 'Προσθήκη στήλης από αριστερά'
            },
            insertRowUp: {
                text: 'Προσθήκη γραμμής από πάνω'
            },
            insertRowDown: {
                text: 'Προσθήκη γραμμής από κάτω'
            },
            deleteColumn: {
                text: 'Διαγραφή στήλης'
            },
            mergeCells: {
                text: 'Συγχώνευση κελιών'
            },
            unmergeCells: {
                text: 'Διάσπαση κελιών'
            },
            deleteRow: {
                text: 'Διαγραφή γραμμής'
            },
            deleteTable: {
                text: 'Διαγραφή πίνακα'
            }
        }
    }
};
const quillConfig = {
    theme: 'snow',
    placeholder: 'Εισάγετε το κείμενό σας',
    modules: {
        table: false,
        'better-table': betterTable,
        toolbar,
        // keyboard: {
        //     bindings: QuillBetterTable.keyboardBindings
        // }
    }
};

const quillPlainTextConfig = {
    theme: 'bubble',
    placeholder: 'Εισάγετε το κείμενό σας',
    modules: {
        table: false,
        'better-table': betterTable,
        toolbar,
        // keyboard: {
        //     bindings: QuillBetterTable.keyboardBindings
        // }
    }
};

@Component({
    selector: 'app-text-editor',
    templateUrl: './text-editor.component.html',
    styleUrls: ['./text-editor.component.scss']
})
export class TextEditorComponent implements OnInit {
    @Output() editorOutputContent = new EventEmitter<any>();
    @Input() plainText = false;
    @Input() isForUsers = false;
    quill: any;
    table: any;

    constructor(public toastService: ToastMessagesService) {
        this.registerModules();
    }

    ngOnInit(): void {
        this.initComponent();
    }

    initComponent(): void {
        const containerEditor = document.querySelector('#quill-editor');
        this.quill = new Quill(containerEditor, this.plainText ? quillPlainTextConfig : quillConfig);
        this.quill.bounds = containerEditor;

        if (!this.plainText) {
            this.table = this.quill.getModule('better-table');
            this.initializeExtraToolbarIcons();
        }
        this.initQuillEvents();
    }

    initQuillEvents(): void {
        this.quill.on('text-change', (delta, oldDelta, source) => {
            if (this.plainText) {
                const data = this.quill.getText();
                this.editorOutputContent.emit(data);
            } else {
                this.editorOutputContent.emit(this.quill.root.innerHTML);
            }
        });
    }

    initializeExtraToolbarIcons(): void {
        const tableToolbarButton = new QuillToolbarButton({
            icon: tableImage,
            label: 'Δημιουργία πίνακα'
        });

        tableToolbarButton.onClick = () => {
            this.table.insertTable(3, 3);
        };
        tableToolbarButton.attach(this.quill);
    }

    registerModules() {
        Quill.register({
            'modules/better-table': QuillBetterTable
        }, true);
    }

    copyLink(stringToCopy: string) {
        const selBox = document.createElement('textarea');
        selBox.style.position = 'fixed';
        selBox.style.left = '0';
        selBox.style.top = '0';
        selBox.style.opacity = '0';
        selBox.value = stringToCopy;
        document.body.appendChild(selBox);
        selBox.focus();
        selBox.select();
        document.execCommand('copy');
        document.body.removeChild(selBox);
        this.toastService.toastMessages(`Ο σύνδεσμος αντιγράφηκε στο πρόχειρό σας`);
    }
}
